import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { AccountType } from 'lumen/services/navigation';

export default class AccountSelectorSubscription extends Model {
  [Type] = 'account-selector-subscription' as const;

  @attr('boolean') declare isActive: boolean | undefined;
  @attr('boolean') declare isInternal: boolean | undefined;
  @attr declare name: string;
  @attr declare salesforceAccountName: string | undefined;
  @attr declare type: AccountType;
}
